import React, { useEffect, useState } from "react";
import Modal, { modalStyles as m } from "./Modal";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";
import { phpVendorList, phpVendorPayout } from "../data/api";
import { fmt } from "../uiUtils";

// Android vendorPayoutDialog: pick the vendor (app/vendor_payment_list), optional remark, confirm
// "Are you sure, you want to pay $X to NAME", then app/vendor_payout paid by cash.
export default function VendorPayoutModal({ amount, onDone, onClose }) {
  const [vendors, setVendors] = useState(null); // null = loading
  const [vendorId, setVendorId] = useState("");
  const [remark, setRemark] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    phpVendorList()
      .then((res) => {
        const rows = res && Array.isArray(res.result) ? res.result : Array.isArray(res) ? res : [];
        if (alive) setVendors(rows);
      })
      .catch(() => alive && setVendors([]));
    return () => {
      alive = false;
    };
  }, []);

  const vid = (v) => (v.vendor_id != null && v.vendor_id !== "" ? v.vendor_id : v.id); // Android VendorNewListModel.Result.vendorId ("vendor_id"), NOT the row id
  const vendor = (vendors || []).find((v) => String(vid(v)) === String(vendorId));
  const vendorName = vendor ? vendor.name || vendor.vendor_name || vendor.title || `#${vendor.id}` : "";

  const ask = () => {
    if (!vendorId) return ToastifyAlert("Select Vendor", "error");
    setConfirm(true);
  };
  const pay = async () => {
    if (typeof navigator !== "undefined" && navigator.onLine === false) return ToastifyAlert("No internet connection", "error");
    setBusy(true);
    try {
      const res = await phpVendorPayout({ vendorId, amount: Number(amount).toFixed(2), remark: remark.trim() });
      if (res && (res.status === true || String(res.status) === "1" || String(res.status).toLowerCase() === "true")) {
        ToastifyAlert("Payout Successful", "success");
        onDone(res);
      } else {
        ToastifyAlert((res && res.message) || "Oops! Something went wrong", "error");
        setConfirm(false);
      }
    } catch {
      ToastifyAlert("Oops! Something went wrong", "error");
      setConfirm(false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal title="Vendor Payout" onClose={onClose}>
      <div style={m.label}>Amount</div>
      <div style={{ fontSize: 28, fontWeight: 800, letterSpacing: "-0.01em", margin: "4px 0 12px" }}>{fmt(amount)}</div>
      <div style={m.label}>Vendor</div>
      <select style={m.input} value={vendorId} onChange={(e) => setVendorId(e.target.value)} disabled={vendors === null}>
        <option value="">{vendors === null ? "Loading vendors…" : "Choose the vendor who will receive this payout"}</option>
        {(vendors || []).map((v) => (
          <option key={vid(v)} value={vid(v)}>{v.name || v.vendor_name || v.title || `#${v.id}`}</option>
        ))}
      </select>
      <div style={{ ...m.label, marginTop: 12 }}>Remark (optional)</div>
      <input style={m.input} value={remark} onChange={(e) => setRemark(e.target.value)} placeholder="Extra info" />
      {confirm ? (
        <>
          <div style={{ marginTop: 14, fontWeight: 500 }}>Are you sure, you want to pay {fmt(amount)} to {vendorName}?</div>
          <button style={m.primary} disabled={busy} onClick={pay}>{busy ? "Paying…" : "Yes, pay"}</button>
          <button style={m.ghost} disabled={busy} onClick={() => setConfirm(false)}>No</button>
        </>
      ) : (
        <>
          <button style={m.primary} onClick={ask}>Make Payout</button>
          <button style={m.ghost} onClick={onClose}>Cancel</button>
        </>
      )}
    </Modal>
  );
}
